export interface ICalendlyBookingPrefill {
  name?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  customAnswers?: Record<string, string>;
}

export interface ICalendlyBookingUtm {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmTerm?: string;
}

export interface ICalendlyBookingDialogData {
  url: string;
  title?: string;
  prefill?: ICalendlyBookingPrefill;
  utm?: ICalendlyBookingUtm;
  hideEventTypeDetails?: boolean;
  hideLandingPageDetails?: boolean;
  hideGdprBanner?: boolean;
  primaryColor?: string;
  textColor?: string;
  backgroundColor?: string;
}

export interface ICalendlyBookingDialogResult {
  scheduled: boolean;
  eventUri?: string;
  inviteeUri?: string;
}
